import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import { fromEvent as observableFromEvent, Subscription } from 'rxjs';
import {NgxSpinnerService} from 'ngx-spinner';
import moment from 'moment/moment';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EditRecommendationComponent } from '../edit-recommendation/edit-recommendation.component';
import { FuseConfigService } from '../../../../core/services/config.service';
import {EventsService} from '../../../../core/services/events.service';
@Component({
  selector: 'recommend-events',
  templateUrl: './recommend-events.component.html',
  styleUrls: ['./recommend-events.component.scss'],
  animations: fuseAnimations,
  standalone: false
})
export class RecommendEvents implements OnInit , OnDestroy {
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  _search = '';
  events = [];
  _pageIndex = 0;
  _perPage = 50;
  eventsLength ;
  displayedColumns = [ 'title' , 'type' , 'organization', 'reserveCount', 'recommended', 'recommendedBy', 'recommendationText' ];
  userId;

  private subscriptions =  new Subscription();

  constructor (private eventService: EventsService , private spinner: NgxSpinnerService,
               public dialog: MatDialog, private translate: TranslateService,
               public toastr: ToastrService, private fuseConfig: FuseConfigService) {
    this.fuseConfig.userId.subscribe((res: any) => {
      if (res) {
        this.userId = res;
      }
    });
  }

  ngOnInit () {
    this.getEvents();
    this.subscriptions.add(observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500) ,
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          this.paginator.firstPage();
          this.cleanScrollEvent();
          this.getEvents();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          this.paginator.firstPage();
          this.cleanScrollEvent();
          this.getEvents();
        }
      }));
  }

  getEvents() {
    this.spinner.show();
    this.eventService.getEventForRecommendation(this._pageIndex + 1, this._perPage, this._search).subscribe((response: any) => {
      this.eventsLength = response.length;
      let events = response.events;
      for (let i = 0; i < events.length; i++) {
        let _dates = '';
        let dateForSort = '2222/01/01';
        if (events[ i ].dates) {
          let divider = ', ';
          if (events[ i ].datesType === 'oneDay') {
            divider = '';
          }
          if (events[ i ].datesType === 'longEvent') {
            divider = ' - ';
          }
          if (events[ i ].datesType === 'fewDays') {
            divider = '/ ';
          }
          if (events[ i ].datesType === 'repeatEvent') {
            divider = ', ';
          }

          let _data = events[ i ].dates.split(',');

          if (_data.length) {
            dateForSort = moment(_data[ 0 ] , 'DD.MM.YYYY').format('YYYY/MM/DD');
          }


          _data.forEach(el => {
            if (_dates) {
              _dates =
                _dates +
                divider +
                moment(el , 'DD.MM.YYYY HH:mm').format('dddd, DD. MMMM YYYY');
            } else {
              _dates = moment(el , 'DD.MM.YYYY HH:mm').format('dddd, DD. MMMM YYYY');
            }
          });
        }
        events[ i ].dateForShow = _dates;
        events[ i ].dateForSort = dateForSort;
        if (new Date(dateForSort).setHours(0 , 0 , 0 , 0) === new Date().setHours(0 , 0 , 0 , 0)) {
          events[ i ].dayColor = '#f2f30f7a';
          events[ i ].dateForSort = '3333/01/01';
        }
        if (new Date(dateForSort).setHours(0 , 0 , 0 , 0) > new Date().setHours(0 , 0 , 0 , 0)) {
          events[ i ].dayColor = '#00800012';
        }
        if (new Date(dateForSort).setHours(0 , 0 , 0 , 0) < new Date().setHours(0 , 0 , 0 , 0)) {
          events[ i ].dayColor = '#ff000014';
        }
      }
      if (events.length) {
        this.events = events.sort((a , b) => {
          return ((new Date(b.dateForSort)).getTime() - (new Date(a.dateForSort)).getTime());
        });
      } else {
        this.events = [];
      }
      this.spinner.hide();
    })
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  cleanScrollEvent() {
    let table = document.getElementById('recommendEvent');
    if (table) {
      table.scrollTop = 0;
    }
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    this.cleanScrollEvent();
    this.getEvents();
  }

  editRecommendation(e, event, readonly = false) {
    e.preventDefault();
    const dialogRef = this.dialog.open(EditRecommendationComponent , {
      width: '500px', data:{ text: event.recommendation[0].recommendation_text, readonly}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          eventId: event.id,
          recommendation_text: result,
          id: event.recommendation[0].id,
        };
        this.eventService.addRecommendation(data).subscribe((res: any) => {
          if (res) {
            let index = this.events.findIndex(el => +el.id === +event.id);
            if (index !== -1) {
              this.events[index].recommendation[0].recommendation_text = res.recommendation_text;
            }
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('event.recommendation_text_edited');
            this.toastr.success(msg, title);
          }
        });
      }
    });
  }
}
